// pages/recruit.js
import Swiper from "swiper";
import { Pagination, A11y, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

function initRecruitSliders() {
  const sliders = document.querySelectorAll(".js-recruit-slider");

  if (sliders.length === 0) return;

  sliders.forEach((slider) => {
    const root = slider.closest(".p-recruit-slider");
    const pagination = root?.querySelector(".js-recruit-slider-pagination");

    if (!pagination) return;

    new Swiper(slider, {
      modules: [Pagination, A11y, Autoplay],

      loop: true,
      speed: 1000,
      centeredSlides: true,
      slidesPerView: "auto",
      spaceBetween: 30,
      grabCursor: true,

      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },

      pagination: {
        el: pagination,
        clickable: true,
      },

      a11y: {
        enabled: true,
        paginationBulletMessage: "{{index}}枚目のスライドへ移動",
      },
    });
  });
}

function initRecruitTabs() {
  const descriptions = document.querySelectorAll(".p-recruit-description");

  if (descriptions.length === 0) return;

  descriptions.forEach((description) => {
    const tabs = Array.from(
      description.querySelectorAll("[data-recruit-tab]"),
    );
    const panels = Array.from(
      description.querySelectorAll("[data-recruit-panel]"),
    );

    if (tabs.length === 0 || panels.length === 0) return;

    const activateTab = (activeTab, focus = false) => {
      const panelId = activeTab.getAttribute("aria-controls");

      if (!panelId) return;

      const activePanel = panels.find((panel) => panel.id === panelId);

      if (!activePanel) return;

      tabs.forEach((tab) => {
        const isActive = tab === activeTab;

        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", String(isActive));
        tab.setAttribute("tabindex", isActive ? "0" : "-1");
      });

      panels.forEach((panel) => {
        const isActive = panel === activePanel;

        panel.classList.toggle("is-active", isActive);
        panel.hidden = !isActive;
      });

      if (focus) {
        activeTab.focus();
      }
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        activateTab(tab);
      });

      tab.addEventListener("keydown", (event) => {
        let nextIndex = null;

        switch (event.key) {
          case "ArrowDown":
          case "ArrowRight":
            nextIndex = (index + 1) % tabs.length;
            break;

          case "ArrowUp":
          case "ArrowLeft":
            nextIndex = (index - 1 + tabs.length) % tabs.length;
            break;

          case "Home":
            nextIndex = 0;
            break;

          case "End":
            nextIndex = tabs.length - 1;
            break;

          default:
            return;
        }

        event.preventDefault();

        activateTab(tabs[nextIndex], true);
      });
    });

    const initialTab =
      tabs.find((tab) => tab.getAttribute("aria-selected") === "true") ??
      tabs[0];

    activateTab(initialTab);
  });
}

export function initRecruitPage() {
  initRecruitSliders();
  initRecruitTabs();
}